import React from "react";
import styles from "./EmptyState.module.css";

const EmptyState = ({ icon = "bi-inbox", title, subtitle, action }) => (
  <div className={styles.wrap}>
    <div className={styles.iconWrap}>
      <i className={`bi ${icon}`} />
    </div>
    {title && <h3 className={styles.title}>{title}</h3>}
    {subtitle && <p className={styles.sub}>{subtitle}</p>}
    {action && <div className={styles.action}>{action}</div>}
  </div>
);

export default EmptyState;
